import "./SystemSettings.css";

import { dashboardData, getSystemFullWithoutClearingPreviousData, clearDashboardData } from '../../stores/actions/dashboardActions';

import BackArrow from "@material-ui/icons/ArrowBackSharp";
import Button from "@material-ui/core/Button";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeatMapInstaller from '../HeatMapInstaller/HeatMapInstaller';
import Map from "@material-ui/icons/Map";
import MapUpload from "../MapUpload/MapUpload";
import { NavLink } from "react-router-dom";
import React from "react";
import SystemParametersSettings from "../SystemParametersSettings/SystemParametersSettings";
import { connect } from 'react-redux';
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import { parseMapBoundaries, loaderStyleEmptyCard } from '../../helpers/CustomStyles';
import { setCurrentNodeID } from '../../stores/actions/actions';
import withStyles from "@material-ui/core/styles/withStyles";
import MapLoading from '../../views/Dashboard/MapLoading';
import Loading from '../../components/Loading/Loading';

class SystemSettings extends React.Component {
  state = {
    updateData: false,
    failedUpload: false,
    clearAllButtonClicked: false,
    firstRender: true,
    isSystemLoading: true,
    invalidParam: false
  }
  closeSaveParametersSettingsTimeout = null;

  componentWillMount() {
    this.props.clearDashboardData();
    const param = this.props.match?.params?.id;
    if (param) {
        const systemId = parseInt(param);
        if (!isNaN(systemId)) {
            this.props.dashboardData(systemId);
        } else {
            this.setState({ invalidParam: true })
        }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSystemLoading && this.props.system?.ID === parseInt(this.props.match.params.id)) {
        this.setState({ isSystemLoading: false });
    }
    if (prevState.isSystemLoading === true && this.state.isSystemLoading === false) {
        this.setState({ firstRender: false });
    }
  }

  updateParent = () => {
    this.setState({ updateData: !this.state.updateData })
  }

  render() {
    const {
      nodes,
      classes,
      system,
      forbidden,
      isNodesLoading,
      isMapLoading,
      systemMapDataBlob,
      accountCategory
    } = this.props;

    if (forbidden || this.state.invalidParam || accountCategory !== 'wisene' && accountCategory !== 'installer') {
        return <div style={{ padding: "10px", ...loaderStyleEmptyCard }}>403</div>;
    }
    if (this.state.isSystemLoading || isNodesLoading) {
        return <MapLoading />
    }
    const { firstRender } = this.state;
    const mapObjectsBoundaries = parseMapBoundaries(system.mapObjectsBoundaries);

    return (
      <div className="systemSettings">
        <GridContainer >
          <GridItem xs={12}>
            <NavLink to={`/systems/${system.ID}/dashboard`}>
              <Button
                size="small"
                data-testid="goToDashboard"
              >
                <BackArrow /> Dashboard
              </Button>
            </NavLink>
            <Card style={{ position: "relative" }}>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Map />
                </CardIcon>
                <GridItem xs={12} >
                  <h5 className={classes.cardIconTitle} style={{ color: "#3C4858" }}>Map </h5>
                </GridItem>
              </CardHeader>
              {/* Show loading when map not downloaded yet or does not exist in DB */}
              {isMapLoading || !system.mapSizeX ? (
                  <div style={loaderStyleEmptyCard}>
                      <Loading transform={0.85} height={90} width={70} color='gray' />
                  </div>
              ) : (
              <HeatMapInstaller
                systemId={system.ID}
                mapHeight={system.mapSizeY ?? 0}
                mapWidth={system.mapSizeX ?? 0}
                mapBoundaries={mapObjectsBoundaries}
                mainMapDataBlob={systemMapDataBlob}
                nodes={nodes}
                firstRender={firstRender}
                updateParent={this.updateParent}
              />)}
            </Card>
          </GridItem>
        </GridContainer>
        <SystemParametersSettings currentSystem={system} updateParent={this.updateParent} accountCategory={accountCategory} />
        <GridContainer>
          <GridItem xs={12}>
            <MapUpload currentSystem={system} updateParent={this.updateParent} />
          </GridItem>
          {/* <GridItem xs={12} md={6}>
            <ClientLogoUpload currentSystem={currentSystem} />
          </GridItem> */}
        </GridContainer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    nodes: state.dashboard.nodes,
    system: state.dashboard.system,
    forbidden: state.dashboard.forbidden,
    isNodesLoading: state.dashboard.isNodesLoading,
    isMapLoading: state.dashboard.isMapLoading,
    systemMapDataBlob: state.dashboard.systemMapDataBlob,
    accountCategory: state.login.accountCategory
  }
}
const actions = {
  dashboardData,
  setCurrentNodeID,
  getSystemFullWithoutClearingPreviousData,
  clearDashboardData
};


const systemSettingsWithStyles = withStyles(dashboardStyle)(SystemSettings);
export default connect(mapStateToProps, actions)(systemSettingsWithStyles);